import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import { handleLoginRedirect } from '../../utils/locationUtils';
import './Navbar.css';
import logo from '../../assets/images/edc-logo-light.png';
import logoDark from '../../assets/images/edc-logo.png';
import { HiMenu, HiX } from 'react-icons/hi';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Check if we're on the our-purpose page
  const isOurPurposePage = location.pathname === '/our-purpose';

  // Check if we're on the international page
  const isInternationalPage = location.pathname === '/international';

  // Define the drop-in animation using react-spring
  const dropIn = useSpring({
    from: { transform: 'translateY(-100%)', opacity: 0 },
    to: { transform: 'translateY(0%)', opacity: 1 },
    config: { tension: 150, friction: 30, duration: 1000 },
  });

  // Function to handle external navigation for the Login button
  const handleLoginClick = () => {
    handleLoginRedirect();
  };

  // Function to handle navigation to home page for the Explore EDC Worldwide button
  const handleExploreClick = () => {
    window.location.href = '/';
  };

  // Function to toggle the mobile menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(prev => !prev);
  };

  return (
    <>
      {/* Desktop Navbar */}
      <animated.nav
        style={dropIn}
        className={`navbar ${isOurPurposePage ? 'navbar-inverted' : ''} ${
          isInternationalPage ? 'navbar-international' : ''
        }`}
      >
        <Link style={{ maxHeight: '28px' }} to="/">
          <img
            src={isOurPurposePage ? logoDark : logo}
            alt="EDC SQUARED Logo"
            className="logo-image"
          />
        </Link>

        <div className="nav-container">
          {isInternationalPage ? (
            <button
              className="international-explore-button"
              onClick={handleExploreClick}
            >
              EXPLORE EDC WORLDWIDE
            </button>
          ) : (
            <>
              <ul className="nav-links">
                <li>
                  <Link to="/edc-hive" className="nav-button">
                    The EDC Hive
                  </Link>
                </li>
                <li>
                  <Link to="/for-creators" className="nav-button">
                    For Creators
                  </Link>
                </li>
                <li>
                  <Link to="/for-brands" className="nav-button">
                    For Brands
                  </Link>
                </li>
                <li>
                  <Link to="/our-purpose" className="nav-button">
                    Our Purpose
                  </Link>
                </li>
                <li>
                  <Link to="/lets-talk" className="nav-button">
                    Let's Connect
                  </Link>
                </li>
              </ul>
              <button className="login-button" onClick={handleLoginClick}>
                Login / Sign Up
              </button>
            </>
          )}
        </div>
      </animated.nav>

      {/* Mobile Navbar Background */}
      <div
        className={`mobile-navbar-background ${
          isOurPurposePage ? 'mobile-navbar-background-inverted' : ''
        }`}
      />

      {/* Mobile Navbar */}
      <div
        className={`mobile-navbar ${
          isOurPurposePage ? 'mobile-navbar-inverted' : ''
        } ${isInternationalPage ? 'mobile-navbar-international' : ''}`}
      >
        <div className="mobile-navbar-header">
          <Link to="/">
            <img
              src={isOurPurposePage ? logoDark : logo}
              alt="EDC SQUARED Logo"
              className="logo-image"
            />
          </Link>
          <button className="mobile-menu-icon" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? <HiX size={30} /> : <HiMenu size={30} />}
          </button>
        </div>
        {isMobileMenuOpen && (
          <div className="mobile-nav-links">
            {isInternationalPage ? (
              <button
                className="international-explore-button"
                onClick={handleExploreClick}
              >
                EXPLORE EDC WORLDWIDE
              </button>
            ) : (
              <>
                <ul>
                  <li>
                    <Link
                      to="/edc-hive"
                      className="nav-button"
                      onClick={toggleMobileMenu}
                    >
                      The EDC Hive
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/for-creators"
                      className="nav-button"
                      onClick={toggleMobileMenu}
                    >
                      For Creators
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/for-brands"
                      className="nav-button"
                      onClick={toggleMobileMenu}
                    >
                      For Brands
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/our-purpose"
                      className="nav-button"
                      onClick={toggleMobileMenu}
                    >
                      Our Purpose
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/lets-talk"
                      className="nav-button"
                      onClick={toggleMobileMenu}
                    >
                      Let's Connect
                    </Link>
                  </li>
                </ul>
                <button className="login-button" onClick={handleLoginClick}>
                  Login / Sign Up
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Navbar;
